import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/betShopManagement/reports/incomes/filter'; // Importing Filter component
import Table from 'views/betShopManagement/reports/incomes/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * IncomesView class extending JetView to create a view for income reports.
 */
export default class IncomesView extends JetView {
    /**
     * Configures the layout and components of the IncomesView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            type: 'wide',
            rows: [],
        };
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Page size options
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Ingresos'), // Filename for export
                                    ignore: { rating: true }, // Ignore rating column
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Ingresos'), // Filename for export
                                        autowidth: true, // Auto width for PDF
                                        ignore: { rating: true }, // Ignore rating column
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                Filter, // Including Filter component
                Table, // Including Table component
                toolbar, // Including toolbar
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Form view for layout
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left column containing components
                },
            ],
        };
    }
}

// FILE DOCUMENTED
